import * as React from "react";
import { useEffect, useState } from "react";
import { IdStyles } from "../../less/IdStyles";
import { TradeArea } from "./TradeArea";
import { TradeTabs } from "./TradeTabs";
import { IdTradePanelTab, UiDefinitionTabBuy, UiDefinitionTabSell, } from "./UIDefinitionTradePanel";
export var TradePanel = function (_a) {
    var item = _a.item, maxStorage = _a.maxStorage;
    var DefaultSliderValue = 1;
    var _b = useState(0), activeTabIndex = _b[0], setActiveTabIndex = _b[1];
    var _c = useState(DefaultSliderValue), sliderValue = _c[0], setSliderValue = _c[1];
    var _d = useState([]), tabs = _d[0], setTabs = _d[1];
    useEffect(function () {
        resetStateFromProps();
    }, [item, item.amount.toNumber()]);
    var resetStateFromProps = function () {
        var buyValue = item.buyValue, sellValue = item.sellValue;
        var newTabs = [];
        if (buyValue) {
            newTabs.push(UiDefinitionTabBuy);
        }
        if (sellValue) {
            newTabs.push(UiDefinitionTabSell);
        }
        var tabIndex = newTabs.length > activeTabIndex ? activeTabIndex : 0;
        var newSliderValue = getSliderInitialValue(newTabs, tabIndex);
        setActiveTabIndex(tabIndex);
        setSliderValue(newSliderValue);
        setTabs(newTabs);
    };
    var handleTabClick = function (tabIndex) {
        var newSliderValue = getSliderInitialValue(tabs, tabIndex);
        setActiveTabIndex(tabIndex);
        setSliderValue(newSliderValue);
    };
    var getSliderInitialValue = function (panelTabs, tabIndex) {
        var activeTab = panelTabs[tabIndex];
        if (activeTab && activeTab.id === IdTradePanelTab.Sell) {
            return item.amount.toNumber();
        }
        else {
            return item.amount.equals(maxStorage) ? 0 : DefaultSliderValue;
        }
    };
    var onSliderChange = function (value) {
        setSliderValue(value);
    };
    if (tabs.length) {
        return (React.createElement("div", { className: "farm-management-detail__tabs" },
            React.createElement("div", { className: "tabs-row " + IdStyles.FarmManagementTabHeaderBackground },
                React.createElement(TradeTabs, { activeTabIndex: activeTabIndex, tabs: tabs, onClick: handleTabClick })),
            React.createElement(TradeArea, { sliderValue: sliderValue, maxStorage: maxStorage, item: item, activeTabIndex: activeTabIndex, onSliderChange: onSliderChange, tabs: tabs })));
    }
    return React.createElement(React.Fragment, null);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/farm-management/TradePanel.tsx
// module id = 2649
// module chunks = 3